document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('click', function (e) {
    // Check if the clicked element matches the selector
    if (e.target.matches('.product-related-products-block__grid .product-variant-picker__image-list .clr-swatch-cls')) {
        const _this = e.target;

        // Remove 'selected' class from all siblings
        const parentCard = _this.closest('.vertical-product-card');
        const colorSwatchParents = parentCard.querySelectorAll('.color-swatch-select-parent');
        colorSwatchParents.forEach(function (parent) {
            parent.classList.remove('selected');
        });

        // Add 'selected' class to the current item
        _this.closest('.color-swatch-select-parent').classList.add('selected');

        // Update image source
        const img = _this.getAttribute('data-product-image');
        const imgElement = parentCard.querySelector('.vertical-product-card__image-wrapper img');
        imgElement.setAttribute('srcset', img);
        imgElement.setAttribute('src', img);

        // Update tooltip and title
        const tooltip = _this.querySelector('.tooltip').textContent.trim();
        const colorLabel = parentCard.querySelector('.color-label-cls .product-variant-picker__option-active-color');
        colorLabel.textContent = tooltip;

        const title = _this.getAttribute('data-product-title');
        const titleElement = parentCard.querySelector('.vertical-product-card__title');
        titleElement.textContent = title;

        // Update link
        const url = _this.getAttribute('data-product-url');
        const link = parentCard.querySelector('a');
        link.setAttribute('href', url);

        // Pricing logic
        const reg = _this.getAttribute('data-prouct-reg');
        const comp = _this.getAttribute('data-prouct-comp');
        const lnt = parentCard.querySelector('.def-comp-cls') !== null;

        if (comp !== '') {
            if (lnt) {
                // Show comparison price
                const defCompCls = parentCard.querySelector('.def-comp-cls');
                defCompCls.classList.remove('hidden');
                const cstmSalePrCls = parentCard.querySelector('.cstm-sale-prc-cls');
                cstmSalePrCls.classList.add('hidden');

                const highlightSalePrice = parentCard.querySelector('.vertical-product-card__price-item--highlight-sale');
                highlightSalePrice.textContent = '';
                defCompCls.textContent = '';
                highlightSalePrice.textContent = reg;
                defCompCls.textContent = comp;

                // Add highlight class
                const priceItem = parentCard.querySelector('.vertical-product-card__price-item');
                if (!priceItem.classList.contains('vertical-product-card__price-item--highlight-sale')) {
                    priceItem.classList.add('vertical-product-card__price-item--highlight-sale');
                }
            } else {
                // Show custom sale price
                const cstmSalePrCls = parentCard.querySelector('.cstm-sale-prc-cls');
                cstmSalePrCls.classList.remove('hidden');
                const regCls = parentCard.querySelector('.reg-clsss');
                regCls.classList.add('hidden');

                cstmSalePrCls.querySelector('.vertical-product-card__price-item--highlight-sale').textContent = reg;
                cstmSalePrCls.querySelector('.vertical-product-card__old-price-item--highlight-sale').textContent = comp;

                // Add highlight class
                const priceItem = parentCard.querySelector('.vertical-product-card__price-item');
                if (!priceItem.classList.contains('vertical-product-card__price-item--highlight-sale')) {
                    priceItem.classList.add('vertical-product-card__price-item--highlight-sale');
                }
            }
        } else {
            // Show regular price
            const regCls = parentCard.querySelector('.reg-clsss');
            regCls.classList.remove('hidden');
            const cstmSalePrCls = parentCard.querySelector('.cstm-sale-prc-cls');
            cstmSalePrCls.classList.add('hidden');

            const priceItem = parentCard.querySelector('.vertical-product-card__price-item');
            priceItem.textContent = reg;
            priceItem.classList.remove('vertical-product-card__price-item--highlight-sale');
            parentCard.querySelector('.def-comp-cls')?.classList.add('hidden');
        }
    }
});



 document.addEventListener('click', function (e) {
    if (e.target.matches('.new-prod-temp-cstm-cls .product-variant-picker__image-list .clr-swatch-cls')) {
        const _this = e.target;

        // Remove 'selected' class from all siblings
        const colorSwatchSelectParent = _this.closest('.product-card__info').querySelectorAll('.color-swatch-select-parent');
        colorSwatchSelectParent.forEach(function (parent) {
            parent.classList.remove('selected');
        });

        // Add 'selected' class to the current item
        _this.closest('.color-swatch-select-parent').classList.add('selected');

        // Update image source
        const img = _this.getAttribute('data-product-image');
        const imgElement = _this.closest('.product-card').querySelector('.product-card__images-wrapper .product-card__images img');
        imgElement.setAttribute('srcset', img);
        imgElement.setAttribute('src', img);

        // Update tooltip and title
        const tooltip = _this.querySelector('.tooltip').textContent.trim();
        _this.closest('.product-card__info').querySelector('.color-label-cls .product-variant-picker__option-active-color').textContent = tooltip;

        const title = _this.getAttribute('data-product-title');
        _this.closest('.product-card__info').querySelector('.product-card__title').textContent = title;

        // Update link
        const url = _this.getAttribute('data-product-url');
        _this.closest('.product-card').querySelector('a').setAttribute('href', url);

        // Pricing logic
        const lnt = _this.closest('.product-card__info').querySelectorAll('.def-comp-cls').length > 0;
        const regg = _this.getAttribute('data-prouct-reg');
        const compp = _this.getAttribute('data-prouct-comp');

        if (compp !== '') {
            if (lnt) {
                const defCompCls = _this.closest('.product-card__info').querySelector('.def-comp-cls');
                defCompCls.classList.remove('hidden');
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.add('hidden');
                _this.closest('.product-card__info').querySelector('.product-card__price-item--highlight-sale').innerHTML = `<span>${regg}</span>`;
                defCompCls.innerHTML = `<span>${compp}</span>`;

                if (!_this.closest('.product-card__info').querySelector('.product-card__price-item').classList.contains('product-card__price-item--highlight-sale')) {
                    _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.add('product-card__price-item--highlight-sale');
                }
            } else {
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.remove('hidden');
                _this.closest('.product-card__info').querySelector('.reg-clsss').classList.add('hidden');
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls .product-card__price-item--highlight-sale').innerHTML = `<span>${regg}</span>`;
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls .product-card__price-item-old--highlight-sale').innerHTML = `<span>${compp}</span>`;

                if (!_this.closest('.product-card__info').querySelector('.product-card__price-item').classList.contains('product-card__price-item--highlight-sale')) {
                    _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.add('product-card__price-item--highlight-sale');
                }
            }
        } else {
            _this.closest('.product-card__info').querySelector('.reg-clsss').classList.remove('hidden');
            _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.add('hidden');
            _this.closest('.product-card__info').querySelector('.product-card__price-item').innerHTML = `<span>${regg}</span>`;
            _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.remove('product-card__price-item--highlight-sale');
            _this.closest('.product-card__info').querySelector('.def-comp-cls')?.classList.add('hidden');
        }
    }
});

 document.addEventListener('click', function (e) {
    if (e.target.matches('recently-viewed .product-variant-picker__list .clr-swatch-cls')) {
        const _this = e.target;
        // Remove 'selected' class from all siblings
        const colorSwatchSelectParent = _this.closest('.product-card__info').querySelectorAll('.color-swatch-select-parent');
        colorSwatchSelectParent.forEach(function (parent) {
            parent.classList.remove('selected');
        });

        // Add 'selected' class to the current item
        _this.closest('.color-swatch-select-parent').classList.add('selected');

        // Update image source
        const img = _this.getAttribute('data-product-image');
        const imgElement = _this.closest('.product-card').querySelector('.product-card__images-wrapper .product-card__images img');
        imgElement.setAttribute('srcset', img);
        imgElement.setAttribute('src', img);

        // Update tooltip and title
        const tooltip = _this.querySelector('.tooltip').textContent.trim();
        _this.closest('.product-card__info').querySelector('.color-label-cls .product-variant-picker__option-active-color').textContent = tooltip;

        const title = _this.getAttribute('data-product-title');
        _this.closest('.product-card__info').querySelector('.product-card__title').textContent = title;

        // Update link
        const url = _this.getAttribute('data-product-url');
        _this.closest('.product-card').querySelector('a').setAttribute('href', url);

        // Pricing logic
        const lnt = _this.closest('.product-card__info').querySelectorAll('.def-comp-cls').length > 0;
        const regg = _this.getAttribute('data-prouct-reg');
        const compp = _this.getAttribute('data-prouct-comp');

        if (compp !== '') {
            if (lnt) {
                const defCompCls = _this.closest('.product-card__info').querySelector('.def-comp-cls');
                defCompCls.classList.remove('hidden');
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.add('hidden');
                _this.closest('.product-card__info').querySelector('.product-card__price-item--highlight-sale').innerHTML = `<span>${regg}</span>`;
                defCompCls.innerHTML = `<span>${compp}</span>`;

                if (!_this.closest('.product-card__info').querySelector('.product-card__price-item').classList.contains('product-card__price-item--highlight-sale')) {
                    _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.add('product-card__price-item--highlight-sale');
                }
            } else {
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.remove('hidden');
                _this.closest('.product-card__info').querySelector('.reg-clsss').classList.add('hidden');
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls .product-card__price-item--highlight-sale').innerHTML = `<span>${regg}</span>`;
                _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls .product-card__price-item-old--highlight-sale').innerHTML = `<span>${compp}</span>`;

                if (!_this.closest('.product-card__info').querySelector('.product-card__price-item').classList.contains('product-card__price-item--highlight-sale')) {
                    _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.add('product-card__price-item--highlight-sale');
                }
            }
        } else {
            _this.closest('.product-card__info').querySelector('.reg-clsss').classList.remove('hidden');
            _this.closest('.product-card__info').querySelector('.cstm-sale-prc-cls').classList.add('hidden');
            _this.closest('.product-card__info').querySelector('.product-card__price-item').innerHTML = `<span>${regg}</span>`;
            _this.closest('.product-card__info').querySelector('.product-card__price-item').classList.remove('product-card__price-item--highlight-sale');
            _this.closest('.product-card__info').querySelector('.def-comp-cls')?.classList.add('hidden');
        }
    }
});

// product size popup
var modal = document.getElementById("flModel");
var body = document.body;
var btn = document.getElementById("size-chart-link");
var span = document.getElementsByClassName("fl_close")[0];

if (btn && modal) {
  btn.onclick = function() {
    modal.style.display = "block";
    body.classList.add("set_index");
  }
}

if (span && modal) {
  span.onclick = function() {
    modal.style.display = "none";
    body.classList.remove("set_index");
  }
}

if (modal) {
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      body.classList.remove("set_index");
    }
  }
}
  
});




